import { render, staticRenderFns } from "./BenefitsTable.vue?vue&type=template&id=6780cde7"
import script from "./BenefitsTable.vue?vue&type=script&lang=js"
export * from "./BenefitsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports